var components
try {
  components = {
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 =
    _vm.info.orderStatus == 6 ? (_vm.info.refundMoney || 0).toFixed(2) : null
  var g1 = _vm.info.goodsorderDetailList && _vm.info.goodsorderDetailList.length
  var l0 = g1
    ? _vm.__map(_vm.info.goodsorderDetailList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g2 = (item.price || 0).toFixed(2)
        return {
          $orig: $orig,
          g2: g2,
        }
      })
    : null
  var g3 = ((_vm.info.totalPrice || 0) - (_vm.info.mailPrice || 0)).toFixed(2)
  var g4 = (_vm.info.mailPrice || 0).toFixed(2)
  var g5 = (_vm.info.couponPrice || 0).toFixed(2)
  var g6 = (_vm.info.integral || 0).toFixed(2)
  var g7 = (_vm.info.price || 0).toFixed(2)
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.showDone = false
    }
    _vm.e1 = function ($event) {
      _vm.showCancel = false
    }
    _vm.e2 = function ($event) {
      _vm.showDelete = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        l0: l0,
        g3: g3,
        g4: g4,
        g5: g5,
        g6: g6,
        g7: g7,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }